import { Component } from '@angular/core';
import { ShowComponent } from 'src/app/common/component/show.component';

@Component({
	selector: 'app-convenience',
	templateUrl: './convenience.component.html',
	styleUrls: ['./convenience.component.css'],
})
export class ConvenienceComponent extends ShowComponent {
	protected apiType = 'bag';
	protected apiUrlAdd = '/product/convenience/';
	protected parentComponent = 'codebook/product_convenience';
	parentLocationSet = [];
	isEmpty = false;
	codebook;
	conveniences;
	protected pageTitleGenerate(): string {
		return `Słowniki -> 
			${this.codebook.name}
			-> 
			${this.data.name}
			(ID:
			${this.data.id}
			)`;
	}

	data = {
		id: null,
		name: '',
		convenience: null,
		multimedia: { id: '', name: '', url: '' },
	};

	protected convertData(data: any) {
		if (data.multimedia === null) {
			data.multimedia = {
				id: '',
				url: '',
				name: '',
			};
		}

		return data;
	}
	protected getApiUrl(): string {
		return '/product/convenience/' + this.data.id + '/';
	}

	protected submitConvert(data: any) {
		return {
			id: data.id,
			name: data.name,
			convenience: data.convenience,
			multimedia: data.multimedia.id,
		};
	}

	protected loadBefore(): void {
		this.bag.get('/codebook/6/', (result, error) => {
			this.codebook = result;
			this.loadData();
		});
		this.bag.get('/product/convenience/', (result, error) => {
			this.conveniences = result.results;
			this.loadData();
		});
	}

	protected submitAfter(): void {
		this.router.navigate([this.parentComponent]);
	}

	checkFormBeforeSubmit() {
		if (
			this.conveniences.find((obj) => obj.name == this.data.name && obj.convenience == this.data.convenience) !=
			undefined
		) {
			this.infobox.error('Takie udogodnienie już istnieje!');
			return;
		}

		if (this.isEmpty == true) {
			this.infobox.error('Uzupełnij poprawnie wszytkie pola!');
			return;
		}
		this.submit();
	}

	isEmptyCheck() {
		const singleChar = this.data.convenience.split('');
		if (singleChar.find((item) => item == ' ') == undefined) {
			this.isEmpty = false;
		} else {
			this.isEmpty = true;
		}
	}

	onFileSelected(event): void {
		this.bag.upload('/multimedia/file/', event.target.files[0], (result, error) => {
			this.data.multimedia = result;
		});
	}

	deleteImage() {
		this.data.multimedia = { id: '', url: '', name: '' };
	}
}
